import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Observable, switchMap, tap } from 'rxjs';
import { GeoCoordService } from '../../../../../shared/services/geoCoord.service';

@Component({
  selector: 'app-structure-address-form',
  templateUrl: './structure-address-form.component.html',
  standalone: false,
})
export class StructureAddressFormComponent implements OnInit {
  @Input() public form: FormGroup<any>;
  @Input() public submitted: boolean;

  public isMainAddress: boolean;
  public searching: boolean = false;
  public searchFailed: boolean = false;

  constructor(private readonly geoCoordService: GeoCoordService) {}

  ngOnInit(): void {
    this.isMainAddress = this.form?.controls.main?.value;
  }

  public search: (text$: Observable<string>) => Observable<any[]> = (text$: Observable<string>): Observable<any[]> =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((text: string) => (text.length < 1 ? [] : this.geoCoordService.getAddresses(text).pipe(tap(() => (this.searchFailed = false))))),
      tap(() => (this.searching = false)),
    );

  public onSelectItem(event: any): void {
    event.preventDefault();
    if (event && event.item) {
      this.form.controls.address.setValue(event.item);
      this.form.controls.postalCode.setValue(event.item.properties.postcode);
      this.form.controls.city.setValue(event.item.properties.city);
      this.form.controls.geoJSON.setValue(event.item);
    }
  }

  public onBlur(input: any): void {
    if (input && input.value === '') {
      this.form.controls.address.setValue(undefined);
    }
  }

  public inputFormat: (value: any | string) => string = (value: any | string): string => value.properties.name;

  public resultFormat: (value: any) => string = (value: any): string => value.properties.label;
}
